import { Modal } from 'antd';
import styles from './index.module.sass';
import { FilledMixingStep, MixingStep } from '../mixing-step';
import ArrowDown from '../../images/arrow-down-short.svg';
import { useEffect, useState } from 'react';

export const SingleRecipeStepsModal = ({
  display,
  closeFn,
  data,
  multi,
  presetExpanded,
}: ISingleRecipeStepsModal) => {
  const [stepsData, setStepsData] = useState<any>([]);
  useEffect(() => {
    if (data) {
      const dataToReform = data;
      dataToReform.steps = data.steps?.map((item: any) => ({
        ...item,
        expanded: true,
      }));
      if (presetExpanded || presetExpanded === 0) {
        dataToReform.steps = data.steps?.map((item: any, i: number) => {
          if (i === +presetExpanded) {
            return { ...item, expanded: true };
          } else {
            return { ...item, expanded: false };
          }
        });
      }
      setStepsData(dataToReform);
    }
  }, [data, presetExpanded]);

  useEffect(() => {
    return () => {
      const dataToReform = data;
      dataToReform.steps = data.steps?.map((item: any) => ({
        ...item,
        expanded: true,
      }));
      setStepsData(dataToReform);
    };
  }, [display]);

  return (
    <Modal
      footer={null}
      onCancel={closeFn}
      open={display}
      width={1440}
      title="шаги миксования"
    >
      <div className={styles.scrollableArea}>
        {data?.bunkers[0].type !== 1 && (
          <FilledMixingStep
            weightArray={[
              data?.part_one?.weight,
              data?.part_two?.weight,
              data?.result?.weight,
            ]}
            multi={data?.bunkers[0].type !== 1}
            bunkers={[data?.steps[0].bp_name_1, data?.steps[0].bp_name_2]}
            totalPrice={data?.result?.price_all}
            profit={data?.result?.price}
          />
        )}
        {stepsData &&
          stepsData?.steps?.map((item: any, i: number) => {
            return (
              <div className={styles.separator}>
                <span
                  className={styles.bpName}
                  style={!item.expanded ? { marginBottom: '0' } : {}}
                  onClick={() => {
                    const updatedData = { ...stepsData };
                    updatedData.steps[i].expanded = !data.steps[i].expanded;
                    setStepsData(updatedData);
                  }}
                >
                  {item.bp_name_1} {item.bp_name_2 && `, ${item.bp_name_2}`}{' '}
                  <img
                    src={ArrowDown}
                    alt="arrow"
                    style={{ transform: item.expanded ? 'rotate(180deg)' : 'none' }}
                  />
                </span>
               { item.expanded && <FilledMixingStep
                  weightArray={[
                    data?.steps[i].info.part_one?.weight,
                    data?.steps[i].info.part_two?.weight,
                    data?.steps[i].info.result?.weight,
                  ]}
                  multi={data?.bunkers[0].type !== 1}
                  bunkers={[data?.steps[i].bp_name_1, data?.steps[i].bp_name_2]}
                  totalPrice={data?.steps[i]?.info?.result?.price}
                  profit={data?.steps[i]?.info?.result?.price_delta}
                />}
                {item.expanded &&
                  data?.steps?.[i]?.steps?.map((item: any, i: number) => (
                    <MixingStep
                      stepNumber={i+1}
                      firstWarehouse={{
                        number: item?.part_one?.bag_id,
                        title: item?.part_one?.warehous_name,
                        weight: item?.part_one?.weight,
                        price: item?.part_one?.price,
                      }}
                      secondWarehouse={{
                        number: item?.part_two?.bag_id,
                        title: item?.part_two?.warehous_name,
                        weight: item?.part_two?.weight,
                        price: item?.part_two?.price,
                      }}
                      finalResult={{
                        number: item?.result?.bag_id,
                        title: item?.result?.warehous_name,
                        weight: item?.result?.weight,
                        price: item?.result?.price,
                        profit: item?.result?.cumulative_increase_value,
                      }}
                    />
                  ))}
              </div>
            );
          })}
        {/* {data?.steps?.[0]?.map((item: any, i: number) => (
                <MixingStep
                  stepNumber={i + 1}
                  firstWarehouse={{
                    number: item?.part_one?.bag_id,
                    title: item?.part_one?.warehous_name,
                    weight: item?.part_one?.weight,
                  }}
                  secondWarehouse={{
                    number: item?.part_two?.bag_id,
                    title: item?.part_two?.warehous_name,
                    weight: item?.part_two?.weight,
                  }}
                  finalResult={{
                    number: item?.result?.bag_id,
                    title: item?.result?.warehous_name,
                    weight: item?.result?.weight,
                  }}
                />
              ))} */}
      </div>
    </Modal>
  );
};

interface ISingleRecipeStepsModal {
  data: any;
  display: boolean;
  closeFn: () => void;
  multi?: boolean;
  presetExpanded?: number;
}
